<template>
  <svg
    ArrowDown
    fill="none"
    stroke-linecap="round"
    stroke-linejoin="round"
    stroke-width="2"
    stroke="currentColor"
    viewBox="0 0 24 24"
  >
    <path d="M19 14l-7 7m0 0l-7-7m7 7V3" />
  </svg>
</template>

<script>
export default {
  name: "IconArrowDown"
};
</script>
